// extracted by mini-css-extract-plugin
module.exports = {"FaqParent":"Faq_styles_FaqParent__3zjCh","FaqHead":"Faq_styles_FaqHead__3g0vG","FaqParagraph":"Faq_styles_FaqParagraph__1oWMs"};